import { Model } from "../Model"

export const useModel = (requestFreshModel?: boolean) => {
    return Model.GetModel(requestFreshModel);
}
